import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { memo } from "react";
import "./Topbar.css";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { FaArrowLeft } from "react-icons/fa6";
import { FaSearch, FaRegBell } from "react-icons/fa";
import { BiLogOut } from "react-icons/bi";
import {
  setId,
  setStaffid,
  setStaffname,
  setEmail,
  setDesignation,
} from "../Redux/actions";

const Header = () => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const apiUrlImage = process.env.REACT_APP_IMAGE_API_BASE_URL;
  const dispatch = useDispatch();
  const [staffData, setstaffData] = useState([]);
  const Id = useSelector((state) => state.id);
  const staffId = useSelector((state) => state.staffid);
  const staffName = useSelector((state) => state.staffname);
  const email = useSelector((state) => state.email);
  const designation = useSelector((state) => state.designation);
  const [filterType, setFilterType] = useState("customer_id");
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const navigate = useNavigate();

  // useEffect(() => {
  //   if (staffId === "") {
  //     navigate("/"); // If logged out, stay on the login page
  //   }
  // }, [staffId, navigate]);

  const [showPopUp, setShowPopUp] = useState(false);

  const handlePopUp = () => {
    setShowPopUp(!showPopUp);
  };
  const goback = (e) => {
    e.preventDefault();
    navigate(-1);
  };

  const handleClose = () => {
    setShowPopUp(false);
  };
  const handleButtonClick = () => {
    setShowPopUp(true);
  };
  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will be logged out!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Logout!",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Logged Out!",
          text: "You have been successfully logged out.",
          icon: "success",
          timer: 2000, // Auto close after 2 seconds
          showConfirmButton: false,
        });

        // Navigate to logout page after 2 seconds
        setTimeout(() => {
          navigate("/logout");
        }, 2000);
      }
    });
  };

  const handleResetPassword = (e) => {
    e.preventDefault();

    Swal.fire({
      title: "Are you sure?",
      text: "You will be redirected to the password reset page.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, proceed",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Redirecting...", "Please wait...", "info");

        setTimeout(() => navigate("/password"), 1000);
      }
    });
  };

  const handleSearch = async (e) => {
    const value = e.target.value;

    // Input validation
    if (
      (filterType === "customer_id" || filterType === "customer_number") &&
      isNaN(value)
    ) {
      return;
    }

    // if (filterType === "customer_name" && /\d/.test(value)) {
    //   return;
    // }

    setSearchTerm(value);

    if (!filterType) {
      alert("Please select a filter type.");
      return;
    }

    // Fetch filtered data
    if (value) {
      try {
        const fieldMap = {
          customer_id: "customerid",
          customer_name: "customername",
          customer_number: "contactnum",
        };

        const response = await axios.get(`${apiUrl}search-customer`, {
          params: {
            filterType,
            searchTerm: value,
          },
        });

        const results = response.data.message || [];
        const dataField = fieldMap[filterType] || filterType;

        // Normalize search term to lowercase for case-insensitive match
        const normalizedSearch = value.toLowerCase();

        // Filter: keep only items where the field starts with the search term
        const filteredResults = results.filter((item) => {
          const fieldValue = String(item[dataField] || "").toLowerCase();
          return fieldValue.includes(normalizedSearch);
        });

        // Then sort the filtered results
        const sortedResults = filteredResults.sort((a, b) => {
          if (dataField === "customername") {
            if (a[dataField].toLowerCase() < b[dataField].toLowerCase())
              return -1;
            if (a[dataField].toLowerCase() > b[dataField].toLowerCase())
              return 1;
            return 0;
          } else {
            const aVal = Number(a[dataField]);
            const bVal = Number(b[dataField]);

            if (isNaN(aVal) && isNaN(bVal)) return 0;
            if (isNaN(aVal)) return 1;
            if (isNaN(bVal)) return -1;

            return aVal - bVal;
          }
        });

        setFilteredData(sortedResults);
        setShowDropdown(results.length > 0);
      } catch (error) {
        console.error("Error fetching filtered data:", error);
      }
    } else {
      setFilteredData([]);
      setShowDropdown(false);
    }
  };

  const handleSelect = (customerid) => {
    navigate("/view_customer", {
      state: { customerid: customerid }, // Pass the customer ID to the edit page
    });
    setShowDropdown(false);
  };

  const gotoNotification = () => {
    navigate("/notification");
  };
  useEffect(() => {
    axios
      .post(
        apiUrl + "viewstaff",

        {}
      )
      .then((res) => {
        setstaffData(res.data.message);
      });
  }, [apiUrl]);
  return (
    <Container fluid className="mt-3 header-container">
      <Row xs={12}>
        <Col sm="auto" xs={12} md={4}>
          <h2 className="text-start">
            Hi, <span style={{ color: "#2A7BBA" }}>{staffName}</span>{" "}
            <span>&#128075;</span>
          </h2>
        </Col>
        <Col md={2}></Col>
        <Col className="xyz header-search " sm="auto" xs={12} md={6}>
          <button onClick={goback} className="arrow">
            <FaArrowLeft className="iconarr " />
          </button>

          {/* <Col sm="auto" xs={12} className="header-search"> */}
          <div className="position-relative">
            <input
              type="text"
              placeholder="Search"
              className="form-control p-2 border-2"
              value={searchTerm}
              onChange={handleSearch}
            />
            <FaSearch className="search-icon" />
            {showDropdown && (
              <ul className="dropdown-menu-custom">
                {filteredData.length > 0 ? (
                  filteredData.map((customer, i) => (
                    <li
                      key={i}
                      className="dropdown-item-custom"
                      onClick={() => handleSelect(customer.customerid)}
                    >
                      {filterType === "customer_id"
                        ? customer.customerid
                        : filterType === "customer_name"
                        ? customer.customername
                        : customer.contactnum}
                    </li>
                  ))
                ) : (
                  <div className="member-dropdown-item">No Data found...</div>
                )}
              </ul>
            )}
          </div>
          <select
            className="inputsearch"
            value={filterType}
            onChange={(e) => {
              setFilterType(e.target.value);
              setSearchTerm("");
              setFilteredData([]);
              setShowDropdown(false);
            }}
          >
            <option value="customer_id">Customer ID</option>
            <option value="customer_name">Customer Name</option>
            <option value="customer_number">Customer Number</option>
          </select>

          <div className="headLast">
            <div className="profile-circle" onClick={handleButtonClick}>
              <span className="initial">{email.charAt(0).toUpperCase()}</span>
            </div>
            <div onClick={() => gotoNotification()} className="notification">
              <FaRegBell size={25} />
              <span className="notification-dot"></span>
            </div>
          </div>
        </Col>
      </Row>
      {showPopUp && (
        <div className="popup-header ">
          <button className="setting-close-btn" onClick={handleClose}>
            &times;
          </button>
          <div className="popup-content">
            <p className="text-center">
              {/* <button className=" btn btn-primary  logopop text-white  ">
                {" "}
                {email.charAt(0).toUpperCase()}
              </button>{" "}
              {email} */}
              <img
                alt="logo"
                // src={apiUrlImage+`${staff?.staffPhoto?.fileName}`}
                src={
                  staffData?.staffPhoto?.fileName
                    ? apiUrlImage + staffData?.staffPhoto?.fileName
                    : apiUrlImage + "default.jpg"
                }
                width={50}
                height={50}
                style={{ borderRadius: "50%", padding: "5px" }}
              />
            </p>
            <div>
              <hr className="hori1" />
            </div>
            <br />

            <container className="fontsize ">
              <Row className="rowsize">
                <Row>
                  <Col className="user">Username</Col>
                  <Col className="colon">:</Col>
                  <Col className="userid">{staffName}</Col>
                </Row>

                <Row>
                  <Col className="  user">Designation</Col>
                  <Col className="colon1">:</Col>
                  <Col className="userid">{designation}</Col>
                </Row>
              </Row>
            </container>

            <hr className="hori1 mt-4" />
            <Row>
              <Col md={6}>
                {/* <h6 className="text-center">Logout</h6> */}

                <button
                  onClick={handleLogout}
                  className="text-center text-primary pt-1 ms-3 logoutbtn"
                >
                  {/* <BiLogOut size={50} /> */}
                  Logout
                </button>
              </Col>
              <Col md={6}>
                {/* <h6 className="text-center">Reset password</h6> */}
                <button
                  onClick={handleResetPassword}
                  className="text-center text-primary pt-1 ms-3 logoutbtn"
                >
                  {/* <BiLogOut size={50} /> */}
                  Reset password
                </button>
              </Col>
            </Row>
          </div>
        </div>
      )}

      <hr />
    </Container>
  );
};

export default memo(Header);
